<template>
    <v-container class="fill-height" style="display: block;" fluid>
        <v-row>
            <v-col cols="12" lg="6">
                <issues-colors :issuesColors="$props.issuesSettings.issuesColors"></issues-colors>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import IssuesColors from "@/components/Settings/IssuesColors";
export default {
    name: 'Issues',
    props: ['issuesSettings'],
    components: {
        IssuesColors
    },
    data: () => ({

    }),

    computed: {
    },

    methods: {
    },

    mounted() {

    }

  
};
</script>

<style scoped>

    .card {
        overflow-y: auto;
        /* max-height: calc(100vh - 224px); */
        max-height: calc(100vh - 200px);
        position: relative;
    }

    .card-body {
        overflow-y: auto;
        /* max-height: calc(100vh - 310px); */
        max-height: calc(100vh - 270px);
        position: relative;
    }

    .card-body .disabled {
        color: rgba(255, 255, 255, 0.5);
    }

</style>
